import React from 'react';
import CardActions from '@material-ui/core/CardActions';
import { DeleteButton, EditButton, ListButton } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

const styles = createStyles({
  fields: {
    zIndex: 2,
    display: 'inline-block',
    float: 'right'
  }
});

type Props = {
  basePath: string,
  classes: any,
  data: any,
  resource: string
};

const ShowActions = (props: Props) => (
  <CardActions className={props.classes.fields}>
    <EditButton basePath={props.basePath} record={props.data} />
    <ListButton basePath={props.basePath} />
    <DeleteButton basePath={props.basePath} resource={props.resource} />
  </CardActions>
);

export default withStyles(styles)(ShowActions);



// WEBPACK FOOTER //
// ./src/views/Common/Actions/Show.tsx